import Vue from 'vue'

export const window = {
  namespaced: true,
  state: {
    width: 0,
  },
  mutations: {
    widthSet(state, payload) {
      Vue.set(state, 'width', payload)
    },
  },
}
